<script lang="ts">
  export let variant: 'themed' | '' = '';
  export let style = '';
  export let disabled = false;
</script>

<div class="twism-card {variant}" class:disabled {style} on:click>
  <slot />
</div>

<style lang="scss">
  .twism-card {
    flex: 1;
    border: 1px solid var(--twism-theme-primary500);
    background: #fff;
    border-radius: 14px;
    height: 64px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    flex-direction: row;
    padding: 0 16px;
    cursor: pointer;
    color: #3d3d3d;
    position: relative;
    overflow: hidden;
    transition: background 0.2s ease-in-out;

    &.disabled {
      pointer-events: none;
    }

    &-content {
      display: flex;
      align-items: center;
      flex-direction: row;
      width: 100%;
      z-index: 10;
    }

    @media screen and (min-width: 768px) {
      &:hover {
        background: darken(#fff, 3%);
      }
    }

    &.themed {
      background: var(--twism-theme-backgroundGradient);
      box-shadow: 0px 17px 32px -14px var(--twism-theme-shadowColor);
      color: var(--twism-theme-textAboveBackground);
      border: none;
      z-index: 5;

      @media screen and (min-width: 768px) {
        &:before {
          content: '';
          background: var(--twism-theme-backgroundGradientHover);
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          position: absolute;
          transition: all 0.15s ease;
          pointer-events: none;
          opacity: 0;
          z-index: -1;
        }

        &:hover:before {
          opacity: 1;
        }
      }
    }

    @media screen and (max-width: 468px) and (min-height: 600px) {
      height: 72px;
    }
  }
</style>
